"use client";

import ClickableLink from "@soprisapps/components/components/utilities/ClickableLink";
import { useStores } from "@soprisapps/components/stores/useStores";

export function SkipToSchoolFeedLink() {
  const { interfaceStore } = useStores();
  return (
    <ClickableLink
      href={
        interfaceStore.breakpoint === "break-point-lg"
          ? "#schoolfeed"
          : "#SchoolFeedMobileNav"
      }
      tabIndex={2}
      onClick={
        interfaceStore.breakpoint === "break-point-lg"
          ? () => interfaceStore.toggleSchoolFeedWidgetOpen()
          : undefined
      }
    >
      skip to schoolfeed
    </ClickableLink>
  );
}
